export default __webpack_public_path__ + "static/media/building-map.8e74fd40.png";